const typesOfShopp = [
  {
    id: 1,
    name: 'Compras Gratis'
  },

  {
    id: 0,
    name: 'Compras Pagas'
  }
]

export default typesOfShopp
